import styled, { css } from 'styled-components'
import { color, unit, size } from 'ui/themes/utils'

import Div from 'ui/elements/Div'

export const Picker = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${unit('2')};

  container-type: inline-size;
`

export const Section = styled(Div)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  gap: ${unit('2')};

  padding: ${unit('4')};

  background-color: ${color('Background/Primary')};

  border: ${size('borderWidth')} solid ${color('Misc/Divider')};
  border-radius: ${unit('2')};

  ${({ gap }) => gap && css`
    justify-content: flex-start;

    gap: ${unit(gap)};
  `}

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;

      background-color: ${color('Secondary/Background1')};

      opacity: 0.4;
    `}

  ${({ disableStyling }) =>
    disableStyling &&
    css`
      border: none;

      padding: 0;
    `}
`

export const Durations = styled(Section)`
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: max-content;

  column-gap: ${unit('5')};

  &.no-times {
    @container (min-width: 490px) {
      grid-template-columns: minmax(150px, 20%) 1fr;
      align-items: end;
    }
  }

  @container (min-width: 690px) {
    grid-template-columns: minmax(200px, 20%) 1fr;
    align-items: end;
  }
`

export const Timeslots = styled(Section)`
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: max-content;

  [class^='Field']:not(:first-child) {
    margin-left: 0;
  }

  @container (min-width: 450px) {
    grid-template-columns: repeat(2, 1fr);

    [class^='Field']:not(:first-child) {
      margin-left: auto;
    }
  }
`

export const Period = styled(Section)`
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: max-content;

  [class*='Decorator'] {
    display: none;
  }

  [class^='Field']:not(:first-child) {
    margin-left: 0;
  }

  &.no-times {
    @container (min-width: 310px) {
      grid-template-columns: 1fr min-content 1fr;

      [class*='Decorator'] {
        display: flex;
      }

      [class^='Field']:not(:first-child) {
        margin-left: auto;
      }
    }
  }

  @container (min-width: 550px) {
    grid-template-columns: 1fr min-content 1fr;

    [class*='Decorator'] {
      display: flex;
    }

    [class^='Field']:not(:first-child) {
      margin-left: auto;
    }
  }
`
